import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_8d25542c-8587-482a-aad2-b863376d4177/artifacts/fp4fbbig_base_logo_transparent_background.png"
              alt="KALEM Baustoffhandel"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Ihr zuverlässiger Partner für Premium-Baumaterialien. Deutschlandweite Lieferung für Bauunternehmen, Handwerker und Bauträger.
            </p>
            <div className="space-y-3">
              <a href="tel:+4917912953010" className="flex items-center text-gray-400 hover:text-[#8B1538] transition-colors">
                <Phone className="w-5 h-5 mr-3" />
                <span>0179 / 12 95 310</span>
              </a>
              <a href="mailto:info@kalembaustoffe.de" className="flex items-center text-gray-400 hover:text-[#8B1538] transition-colors">
                <Mail className="w-5 h-5 mr-3" />
                <span>info@kalembaustoffe.de</span>
              </a>
              <div className="flex items-start text-gray-400">
                <MapPin className="w-5 h-5 mr-3 flex-shrink-0 mt-1" />
                <span>Deutschlandweite Lieferung</span>
              </div>
            </div>
          </div>

          {/* Gewerke */}
          <div>
            <h3 className="text-lg font-bold mb-6">Unsere Gewerke</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Hochbau
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Ausbau
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Gala-Bau
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Tiefbau
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Bauelemente
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gewerke');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Fliesen
                </button>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('home');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('ueber-uns');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('warum-kalem');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Vorteile
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('kontakt');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-[#8B1538] transition-colors"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} KALEM Baustoffhandel. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/impressum" className="text-gray-400 hover:text-[#8B1538] transition-colors">
                Impressum
              </a>
              <a href="/datenschutz" className="text-gray-400 hover:text-[#8B1538] transition-colors">
                Datenschutz
              </a>
              <a href="/agb" className="text-gray-400 hover:text-[#8B1538] transition-colors">
                AGB
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};